import { render, staticRenderFns } from "./approvalComponent.vue?vue&type=template&id=47a47749&scoped=true&"
import script from "./approvalComponent.vue?vue&type=script&lang=js&"
export * from "./approvalComponent.vue?vue&type=script&lang=js&"
import style0 from "./approvalComponent.vue?vue&type=style&index=0&id=47a47749&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a47749",
  null
  
)

export default component.exports